import React from "react";
import Image from "gatsby-image/withIEPolyfill";
import { useTheme } from "@emotion/react";

import { PrismicColor } from "utils";

import {
  AspectRatio,
  Box,
  Button,
  ColorMode,
  Column,
  Columns,
  Flex,
  Heading,
  Link,
  RichText,
  VStack,
  Wrapper,
} from "components";

function TextSplit({ title, content, items }) {
  return (
    <Flex
      id={title && title.text}
      bg="brand.primary"
      width="100%"
      height="100%"
      flexDirection="column"
      justifyContent="space-between"
      p="layout.5"
      borderLeftWidth={8}
      borderColor="brand.secondary"
    >
      <ColorMode mode="dark">
        <VStack space={{ _: "layout.4", md: "layout.5" }}>
          {title && title.text && <Heading children={title.text} size={700} />}
          {content && content.html && (
            <RichText
              html={content.html}
              size={500}
              maxWidth="60ch"
              css={{
                a: {
                  color: "white !important",
                  transition: "color 200ms ease-out",
                },
                "a:hover": { color: "yellow" },
              }}
            />
          )}
        </VStack>
        <VStack mt="layout.3" space={{ _: "layout.1" }}>
          {items?.map(({ button_link, button_label }, index) => {
            if (button_link && button_link.url && button_label) {
              return (
                <Box key={`ctaButton-${index}`}>
                  <Link href={button_link.url}>
                    <Button
                      children={button_label}
                      appearance="primary"
                      intent="secondary"
                      round={true}
                    />
                  </Link>
                </Box>
              );
            } else {
              return null;
            }
          })}
        </VStack>
      </ColorMode>
    </Flex>
  );
}

function CallToAction({
  // button_label,
  // button_link,
  content,
  image,
  title,
  background,
  items,
}) {
  const THEME = useTheme();

  if (title && title.text && content && content.html)
    return (
      <Wrapper
        px={{ _: 0, md: "layout.4", lg: "layout.5" }}
        py={{ _: "layout.5", md: "layout.6" }}
        bg={PrismicColor(background)}
      >
        <Columns>
          <Column width={{ _: 1, md: 1 / 2 }}>
            <TextSplit title={title} content={content} items={items} />
          </Column>
          <Column width={{ _: 1, md: 1 / 2 }}>
            {image && image.fluid && (
              <AspectRatio
                ratio="5:4"
                borderLeftWidth={{ _: 8, md: 0 }}
                borderColor="brand.secondary"
              >
                <Image
                  fluid={image.fluid}
                  alt={image.alt}
                  objectFit="cover"
                  objectPosition="0% 100%"
                  css={{
                    width: "100%",
                    height: "100%",
                  }}
                />
                {/* Solid angle scrim */}
                <Box
                  display={{ _: "none", md: "block" }}
                  position="absolute"
                  top={0}
                  left={0}
                  height="100%"
                  pr="10%"
                  css={{
                    background: `linear-gradient(94deg, ${THEME.colors.brand.primary} 49.5%, transparent 50%)`,
                  }}
                />
                {/* Solid angle scrim  - mobile */}
                <Box
                  display={{ _: "block", md: "none" }}
                  position="absolute"
                  top={0}
                  left={0}
                  width="100%"
                  mt="-2px" // Subpixel blocking
                  pb="10%"
                  css={{
                    transform: "rotate(180deg)",
                    background: `linear-gradient(-4deg, ${THEME.colors.brand.primary} 49.5%, transparent 50%)`,
                  }}
                />
              </AspectRatio>
            )}
          </Column>
        </Columns>
      </Wrapper>
    );
  else return null;
}

export default CallToAction;
